export const budgetUsageMeterRange = { min: 80, good: 90, target: 100, caution: 110, max: 120 };

export function formatBudgetUsagePercentLabel(value) {
  return `${Math.round(value)}%`;
}
